import { toast } from "react-toastify";
import httpService from "./httpService";
import config from '../config/apiConfig';


export async function GetDatosConfiguracion(){
  try{
      
      let urlDatosConfiguracion = config.api_url+'configuracion/';
      const token = localStorage.getItem("token");
      const respuesta = await httpService.get(urlDatosConfiguracion, {
      headers: {
        'token': token // El formato que vimos que funciona en tu KDS
      }
      });
      console.log(urlDatosConfiguracion, respuesta);
      return respuesta.data;
    }
    catch(error){
      toast.error("Se ha provocado un error al desplegar los datos de configuración!")
    }
}

const getHeaders = () => ({
    'Content-Type': 'application/json',
    'token': localStorage.getItem('token')
});

export const obtenerSectores = async () => {
    const res = await fetch(`${config.api_url}/api/sectores-despacho`, { headers: getHeaders() });
    return await res.json();
};

export const guardarSector = async (sector) => {

    const isEdit = sector.id ? true : false;
    const url = isEdit ? `${config.api_url}/api/sectores-despacho/${sector.id}` : `${config.api_url}/api/sectores-despacho`;
    const method = isEdit ? 'PUT' : 'POST';

    console.log("url", url)
    const res = await fetch(url, {
        method,
        headers: getHeaders(),
        body: JSON.stringify(sector)
    });
    return await res.json();
};

export const eliminarSector = async (id) => {
    const res = await fetch(`${config.api_url}/api/sectores-despacho/${id}`, {
        method: 'DELETE',
        headers: getHeaders()
    });
    return await res.json();
};

// 1. GET: Listar todas las plataformas
// ===========================================
// 2. CRUD PARA PLATAFORMAS EXTERNAS (Rappi, Uber, etc.)
// (El nuevo mantenedor)
// ===========================================

export const obtenerPlataformasExternas = async () => {
    const res = await fetch(`${config.api_url}/api/plataformas-externas`, { headers: getHeaders() });
    return await res.json();
};

export const guardarPlataforma = async (platformData) => {
    const isEdit = platformData.id ? true : false;
    const url = isEdit 
        ? `${config.api_url}/api/plataformas-externas/${platformData.id}` // PUT
        : `${config.api_url}/api/plataformas-externas`; // POST

    const method = isEdit ? 'PUT' : 'POST';
    
    const res = await fetch(url, {
        method,
        headers: getHeaders(),
        body: JSON.stringify(platformData)
    });
    return await res.json();
};

export const eliminarPlataforma = async (id) => {
    const res = await fetch(`${config.api_url}api/plataformas-externas/${id}`, {
        method: 'DELETE',
        headers: getHeaders()
    });
    return await res.json();
};

// configuracion del sistema negocio
export const fetchConfiguracion = async () => {
    try {
        const token = localStorage.getItem('token'); 
        const response = await fetch(`${config.api_url}/api/configuracion/valores`, {
            method: 'GET', 
            headers: { 
                'Content-Type': 'application/json', 
                'token': token 
            }
        });

        // IMPORTANTE: fetch no lanza error por HTTP 404 o 500, hay que verificar .ok
        if (!response.ok) {
            throw new Error(`Error ${response.status}: No se pudo obtener la configuración`);
        }

        return await response.json();
    } catch (e) { 
        console.error("Error en fetchConfiguracion:", e);
        throw e; // <--- ESTO PROPAGA EL ERROR A LA FUNCIÓN LLAMADORA
    }
};

//parametros y flags 
export const fetchConfiguracionParametros = async () => {
    try {
        const token = localStorage.getItem('token'); 
        const response = await fetch(`${config.api_url}/api/configuracion/parametros/valores`, {
            method: 'GET', 
            headers: { 
                'Content-Type': 'application/json', 
                'token': token 
            }
        });

        // IMPORTANTE: fetch no lanza error por HTTP 404 o 500, hay que verificar .ok
        if (!response.ok) {
            throw new Error(`Error ${response.status}: No se pudo obtener la configuración`);
        }

        return await response.json();
    } catch (e) { 
        console.error("Error en fetchConfiguracion:", e);
        throw e; // <--- ESTO PROPAGA EL ERROR A LA FUNCIÓN LLAMADORA
    }
};